import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-16123766")

_pushScopeId("data-v-16123766")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "p-error" }, "*", -1)
const _hoisted_3 = { class: "p-mb-3" }
const _hoisted_4 = { class: "p-mb-3" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 2,
  class: "p-d-flex p-jc-center p-col-12"
}
const _hoisted_8 = {
  key: 3,
  class: "p-d-flex p-jc-center p-col-12"
}
const _hoisted_9 = {
  key: 4,
  class: "p-d-flex p-jc-center p-col-12"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ListMember = _resolveComponent("ListMember")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: _ctx.header,
    style: { width: '70vw' },
    modal: true,
    "onUpdate:visible": [
      _ctx.handleClose,
      _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDialog = $event))
    ],
    visible: _ctx.showDialog
  }, {
    default: _withId(() => [
      (_ctx.editNameMode)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("div", null, [
              _createVNode("h6", null, [
                _createTextVNode(_toDisplayString(_ctx.$t("workspace.edit.popup.textbox.name")), 1),
                _hoisted_2
              ])
            ]),
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: _ctx.newName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.newName = $event)),
                class: ["input-workspace", {
            'p-invalid': _ctx.newName === '',
          }],
                placeholder: _ctx.$t('workspace.edit.popup.textbox.name'),
                maxlength: "28"
              }, null, 8, ["modelValue", "placeholder", "class"])
            ]),
            _createVNode("div", null, [
              _createVNode("h6", null, _toDisplayString(_ctx.$t("workspace.edit.popup.textbox.description")), 1)
            ]),
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: _ctx.newDescription,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.newDescription = $event)),
                class: "input-workspace",
                placeholder: _ctx.$t('workspace.edit.popup.textbox.description'),
                maxlength: "512"
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.viewMemberMode)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            (_ctx.mode === 'create')
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  _createVNode("h6", null, _toDisplayString(_ctx.$t("workspace.edit.popup.set.member")), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_ListMember, {
              mode: _ctx.mode,
              editable: _ctx.editMemberMode,
              onUpdate: _ctx.updateMembersList
            }, null, 8, ["mode", "editable", "onUpdate"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.mode === 'create')
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode(_component_Button, {
              label: _ctx.$t('button.create_workspace'),
              class: "p-mt-8",
              disabled: _ctx.hasError,
              onClick: _ctx.createWorkspace
            }, null, 8, ["label", "disabled", "onClick"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.mode === 'update')
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _createVNode(_component_Button, {
              label: _ctx.$t('button.save'),
              class: "p-mt-8",
              disabled: _ctx.hasError,
              onClick: _ctx.updateWorkspace
            }, null, 8, ["label", "disabled", "onClick"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.mode === 'assign')
        ? (_openBlock(), _createBlock("div", _hoisted_9, [
            _createVNode(_component_Button, {
              label: _ctx.$t('button.save'),
              class: "p-mt-8",
              disabled: _ctx.hasError,
              onClick: _ctx.updateMembers
            }, null, 8, ["label", "disabled", "onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["header", "onUpdate:visible", "visible"]))
})